import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom'
import { desloginarAction, iniciarPeticioLoginAdminAsincronaAxios, iniciarPeticioLoginPortalCombAsincronaAxios, iniciDesloginar } from '../../actions/auth';
import { recuperarInfoVacancesEntreDates, recuperarVacancesEntreDates } from '../../actions/configCalendariAction';
import { uiResponsable } from '../../actions/ui';
import { RecuperarInfoVacances } from '../CalendariVacances/RecuperarInfoVacances';

export const LoginResp = () => {
    const dispatch = useDispatch(); //Per despachar accions
    const state = useSelector(state => state); // Això retorna l'esta actual de l'aplicació, per poder accedir a tot el contingut emmagatzemat allà
    const { ui } = useSelector(state => state); // Per desestructuració d¡objectes, podem agafar l'objecte desitjat del nostre state
    const { loading, msgError } = useSelector(state => state.ui); //Per desestructuració, podem agafar propietats d'objectes directament
    const { auth } = useSelector(state => state);
    //Farem servir useEffect. Es una eina de REact que permet executar una acció automàticament, afegint una condició de dependencia d'estat o no
    const [primerCop, setPrimerCop] = useState(true);       
    const [msgError2, setMsgError2] = useState(false);   
    const navegacio = useNavigate();
    let params = useParams();

   

    
     useEffect(() => {
        // Caso especial: tokenAcces === "1"
        if(params.tokenAcces !== undefined && primerCop)
       {
         setPrimerCop(false);
            if (params.tokenAcces === "1") {
                console.log("1");
                dispatch(uiResponsable(true));
                navegacio('/calendariVacances');
            }else{   
              console.log("orchard");     
                dispatch(desloginarAction());
                dispatch(uiResponsable(true));
                dispatch(iniciarPeticioLoginPortalCombAsincronaAxios(params.tokenAcces));
                navegacio('/calendariVacances')
              }
           }
    
      }, [params]);
      

  return (
    <div>LoginResp</div>
  )
}
